var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-from-email d-flex justify-content-center align-items-center"},[_c('Loader',{attrs:{"loader-text":_vm.loaderText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }